import { connect } from "react-redux";
import { compose } from "recompose";
import { withApp } from "src/components/App/Context";

import MyAccount from "./MyAccount";

import {
  getUser,
  hasPremium,
  canManageSubscription,
  getSubscription
} from "src/modules/auth/duck/selectors";

function mapStateToProps(state) {
  const user = getUser(state);

  return {
    subscription: getSubscription(state),
    hasPremium: hasPremium(state),
    canManageSubscription: canManageSubscription(state),
    familyName: user.familyName,
    email: user.email || user.optionalEmail,
    isLoggedIn: typeof user.email === "string"
  };
}

const enhance = compose(withApp, connect(mapStateToProps));

export default enhance(MyAccount);
